<template>
<div class="CreateAllowAllElectivesTypeMilestoneActionOverlay">
   <div class="container-fluid">
      <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row margin-left-1Point5Perc">
                <div class="col-md-7 col-lg-7 text-align-left margin-Top-1Point5Perc create-element-overlay-course-title-font-styles">
                  {{selectedGroupObj.GroupName}}
                </div>    
                <div class="col-md-5 col-lg-5">
                  <div class="text-right close-text-font-style margin-right-3Perc cursor-pointer" v-on:click="closeOverlay">
                    <img src= "../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
                  </div>  
                </div>
              </div>
              <div class="row margin-left-1Point5Perc padding-bottom-1Perc bottom-border margin-bottom-2Perc">
                <div class="col-md-12 col-lg-12 text-align-left font-wight-bold create-element-overlay-module-title-font-styles">
                  {{currSelectedExistingMilestoneObjFromList.Title}}
                </div>    
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="row col-md-2 col-lg-2"></div>
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  Milestone Type
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12 text-align-left">
                      <span class="font-weight-bold create-lesson-input-text-style">{{getMilestoneNameUsingMilestoneId(currSelectedExistingMilestoneObjFromList)}}</span>
                    </div>
                  </div>
                </div>
                <div class="row col-md-3 col-lg-3"></div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="row col-md-2 col-lg-2"></div>
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  Action Type
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12 text-align-left">
                      <span class="font-weight-bold create-lesson-input-text-style">{{getMilestoneActionNameUsingActionId(getSelectedMilestoneActionObjValue)}}</span>
                    </div>
                  </div>
                </div>
                <div class="row col-md-3 col-lg-3"></div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="row col-md-2 col-lg-2"></div>
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  Action Title
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <input type="text" v-model="getMilestoneActionTitle" class="form-control">
                    </div>
                  </div>
                </div>
                <div class="row col-md-3 col-lg-3"></div>
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="col-md-5 col-lg-5">
                </div>  
                <div class="col-md-2 col-lg-2">
                  <!-- ToDo: Track this -->
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="createMilestoneAction">Create Action</button>
                </div>  
                <div class="col-md-5 col-lg-5">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box> 
 </div>
 </div>
</template>

<script>
import filter from 'lodash/filter'
import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import { milestoneService } from '@/server-util/milestone-service'
export default {
  props: ['selectedGroupObj', 'selectedMilestoneActionObj', 'currSelectedExistingMilestoneObjFromList'],
  created: function () {
    this.setDefaultValues()
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      milestoneActionObj: {
        MilestoneId: '',
        Title: '',
        Type: '',
        Data: null
      }
    }
  },
  name: 'CreateAllowAllElectivesTypeMilestoneActionOverlay',
  methods: {
    getMilestoneActionNameUsingActionId: function (currMilestoneActionType) {
      var strToReturn = ''
      switch (currMilestoneActionType) {
        case constants.MilestoneActionType.Allow_Specified_Courses:
          strToReturn = 'Allow Specified Course'
          break
        case constants.MilestoneActionType.Allow_All_Electives:
          strToReturn = 'Allow All Electives'
          break
      }
      return strToReturn
    },
    setDefaultValues: function () {
      this.milestoneActionObj.MilestoneId = this.currSelectedExistingMilestoneObjFromList.MilestoneId
      this.milestoneActionObj.Type = this.getSelectedMilestoneActionObjValue
    },
    getMilestoneNameUsingMilestoneId: function (milestoneObj) {
      var currMileStoneObj = filter(this.getMilestoneList, function (o) {
        return o.MilestoneInfoId === milestoneObj.MilestoneInfoId
      })
      if (currMileStoneObj !== undefined && currMileStoneObj !== null && currMileStoneObj !== 'null' && currMileStoneObj.length !== 0) {
        return currMileStoneObj[0].Title
      } else {
        return ''
      }
    },
    closeOverlay: function () {
      var obj = {
        hasMilestoneActionCreatedOrUpdated: false,
        closeOverlay: false,
        type: 'create'
      }
      this.$emit('closeOverlay', obj)
    },
    createMilestoneAction () {
      if (this.validateRequiredFieldBeforeSubmit()) {
        var storeObj = this.$store
        if (storeObj.state.access_token !== undefined && storeObj.state.access_token !== '' && storeObj.state.access_token !== null) {
          this.$store.state.isLoading = true
          var _this = this
          milestoneService
            .addMilestoneAction(
              storeObj.state.access_token,
              this.milestoneActionObj
            )
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                _this.$store.state.isLoading = false
                // AK: Close current create milestone action overlay
                var obj = {
                  hasMilestoneActionCreatedOrUpdated: true,
                  closeOverlay: false,
                  type: 'create'
                }
                _this.$emit('closeOverlay', obj)
              } else {
                _this.$store.state.isLoading = false
                _this.showAlertDialog = true
                _this.errorMsg = 'Oops! Something went wrong. Please try again.'
              }
            }, errorObj => {
              _this.$store.state.isLoading = false
              _this.showAlertDialog = true
              if (errorObj.response === undefined) {
                _this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                _this.errorMsg = errorObj.response.statusText
              }
            })
        } else {
          console.log('FOUND EMPTY ACCESS TOKEN HENCE DECLINED CREATING NEW MILESTONE ACTION OPERATION.')
        }
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    validateRequiredFieldBeforeSubmit: function () {
      if (this.getMilestoneActionTitle.length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Please enter an action title.'
        return false
      }
      return true
    }
  },
  components: {
    'alert-box': AlertBox
  },
  computed: {
    getCurrentSelectedGroupObj: {
      get: function () {
        return this.selectedGroupObj
      }
    },
    getMilestoneList: {
      get: function () {
        return this.$store.state.milestoneInfoList
      }
    },
    getCurrSelectedExistingMilestoneObjFromList: {
      get: function () {
        return this.currSelectedExistingMilestoneObjFromList
      }
    },
    getSelectedMilestoneActionObjValue: {
      get: function () {
        return this.selectedMilestoneActionObj
      }
    },
    getMilestoneActionTitle: {
      get: function () {
        return this.milestoneActionObj.Title
      },
      set: function (newValue) {
        this.milestoneActionObj.Title = newValue
      }
    }
  },
  watch: {}
}
</script>

<style scoped>
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-5Perc
{
	margin-bottom: 5%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-0px
{
  padding-left: 0px !important;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left !important;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

.overflow-x-hidden{
  overflow-x: hidden !important;
}
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 20%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-1Perc {
  margin-right: 1%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 5%;
  height: 5%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color
{
  color: #000 !important;
}
.border-red {
  border: 1px solid red;
}
.font-weight-bold {
  font-weight: 700;
}
.opacity {
  opacity: 0.75;
}
.font-size-12px {
  font-size: 12px;
}
.create-element-overlay-course-title-font-styles {
  font-size: 14px;
  color: #34495e;
}
.create-element-overlay-module-title-font-styles {
  font-size: 20px;
  color: #34495e;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.padding-left-4Point4 {
  padding-left: 4.4%;
}
.margin-left-1Point5Perc
{
  margin-left:1.5%;
}
.margin-right-3Perc {
  margin-right: 3%;
}
.margin-left-2Perc {
  margin-left: 2% !important;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.font-wight-bold {
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/CreateAllowAllElectivesTypeMilestoneActionOverlay.vue